import 'phaser';
import { GameConfig } from './config';
// import { BaseScene } from './scenes/BaseScene';
import { GameScene } from './scenes/GameScene';
// import { MapScene } from './scenes/MapScene';
import { MenuScene } from './scenes/MenuScene';
import { StationScene } from './scenes/StationScene';
import { UIScene } from './scenes/UIScene';
import { TutorialScene } from './scenes/TutorialScene';

class MetroTag extends Phaser.Game {
  constructor() {
    // Initialize the game first
    super({
      type: Phaser.AUTO,
      parent: 'game',
      ...GameConfig,
      scene: [MenuScene, GameScene, StationScene, UIScene, TutorialScene],
    });
    
    // Add a custom handler for errors
    window.addEventListener('error', (e) => {
      console.error('Game error:', e.error || e.message);
    });
  }
}

window.onload = () => {
  new MetroTag();
}; 